import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cassFilter'
})
export class CassFilterPipe implements PipeTransform {
	transform(items: any[], searchTerm: string, propertyName?: string): any[] {
		if (!items || !searchTerm) {
			return items;
		}

		searchTerm = searchTerm.toLowerCase();

		return items.filter(item => {
			if (typeof item === 'object' && propertyName) {
				if (propertyName in item) {
					const propertyValue = item[propertyName];
					if (propertyValue.toString().toLowerCase().includes(searchTerm)) {
						return true;
					}
				}
			} else if (item.toString().toLowerCase().includes(searchTerm)) {
				return true;
			}
			return false;
		});
	}
}
